var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 179.073,
    height: 212.1,
    viewBox: "0 0 179.073 212.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{isolation:isolate;}.b{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 1.06,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f3061"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82140"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(504.939 -496.406)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-399.495,706.385a7,7,0,0,1-2.121-5.151V662.451h-96.051a7,7,0,0,1-5.151-2.121,7,7,0,0,1-2.121-5.152V634.271a14.433,14.433,0,0,1,3.333-9.089l89.385-123.625a10.011,10.011,0,0,1,4.545-3.787,16.044,16.044,0,0,1,6.666-1.364h33.33a7.18,7.18,0,0,1,5.3,1.969,7.177,7.177,0,0,1,1.97,5.3V626.393h27.27a7.176,7.176,0,0,1,5.3,1.97,7.179,7.179,0,0,1,1.97,5.3v21.512a7.3,7.3,0,0,1-1.97,5.152,6.892,6.892,0,0,1-5.3,2.121h-27.27v38.783a7.29,7.29,0,0,1-1.97,5.151,6.885,6.885,0,0,1-5.3,2.121h-26.664A7,7,0,0,1-399.495,706.385Zm-62.721-78.78h61.508v-86.96Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.2ad2370514b56823f21bcf70e54f3c07.svg";
export { ForwardRef as ReactComponent };